export default "__VITE_ASSET__BlP9tKya__"